<template>
    <el-dialog :title="(formData.edit? $t('Update Donation'):$t('Create Donation'))" :visible.sync="dialogFormVisible"
        :before-close="handleClose" @open="handleOpen('formData')" width="40%">
        <el-form label-position="top" :model="formData" ref="formData" :rules="rules">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Donation Amount')" prop="donated_amount">
                    <div class="el-input el-input-group el-input-group--prepend">
                        <div class="el-input-group__prepend">{{ $store.state.config.generalSettings.currency_code }}</div>
                        <input v-model="formData.donated_amount" type="text" autocomplete="off" class="el-input__inner" 
                        v-mask="{'alias': 'numeric', 'groupSeparator': '\'', 'autoGroup': true, 'digits': 2, 'digitsOptional': false, 'prefix': '', 'placeholder': '0'}">
                    </div>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Payment Date')" prop="payment_date">
                    <el-date-picker v-model="formData.payment_date" type="date" :placeholder="$t('Payment Date')"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="(formData.letter_sent_date == undefined && !formData.letter_sent_date)">
                <el-form-item prop="letter_sent">
                    <el-checkbox v-model="formData.letter_sent">{{ $t('Letter Sent?') }}</el-checkbox>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Donation Period')" prop="donation_type">
                    <el-radio-group v-model="formData.donation_type" size="medium">
                        <el-radio-button label="once">{{ $t('Once') }}</el-radio-button>
                        <el-radio-button label="yearly">{{ $t('Yearly') }}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="24">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('formData')">{{ (formData.edit?
                        $t('Update'):$t('Save')) }}</el-button>
                    <el-button type="cancel" @click="$emit('popup',false)">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-col>            
            <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
        </el-form>
    </el-dialog>
</template>

<script>
    import VueGoogleAutocomplete from 'vue-google-autocomplete'
    export default {
        components: {
            VueGoogleAutocomplete
        },
        props: {
            dialogFormVisible: Boolean,
            rowData: Object,
            accountGroups: Object,
            accountClasses: Object
        },
        created() {
            this.spenderId = this.$route.params.spender_id
        },
        data() {
            return {
                formData: {
                    spender_id: this.spenderId
                },
                formLabelWidth: '120px',
                rules: {
                    donated_amount: [{
                        required: true,
                        trigger: ['blur'],
                        message: this.$t('This field is required')
                    }],
                    payment_date: [{
                        required: true,
                        message: this.$t('This field is required')
                    }],
                },
                spenderId: null
            };
        },
        methods: {
            handleOpen() {
                this.formData = Object.assign({}, this.rowData);
                this.$nextTick(() => {
                    this.$refs['formData'].clearValidate();
                })
            },
            handleClose() {
                this.$emit('popup', false)
            },
            updateData(row) {
                return request({
                        url: this.spenderId + "/spender-donations/" + row.id,
                        method: "PATCH",
                        data: row
                    })
                    .then(response => {
                        this.$emit('popupupdate', response.data.data);
                        this.$emit('popup', false);
                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.formData.edit)
                            return this.updateData(this.formData);
                        request({
                                url: this.spenderId + "/spender-donations",
                                method: "post",
                                data: this.formData
                            })
                            .then(response => {
                                this.$emit('popup', false);
                                this.$emit('popupsave', false);
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .el-radio-group label {
        padding: 0;
        text-transform: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/Layout/Spenders/Donation/Form.vue